/*
    Assorted React-related helpers
*/
'use strict';

const ReactUtil = {
    getComponentDisplayName: (component) => {
        return component.displayName || component.name || 'Component';
    },

    isReactEvent: (value) => {
        return !!value && value.nativeEvent instanceof Event;
    }
};

module.exports = ReactUtil;
